import DeliveryPeriod from "domain/deliveryPeriod";
import Event, { EventAction } from "common/event";
import deliveryPeriodService from "./deliveryPeriod.service";
import { ActionWithDispatch } from "common/actionWithDispatch";
import trackApiCall from "features/saveIndicator/trackApiCall";
import Throttle from "common/decorators/throttle";
import loggingService from "common/logging/loggingService";
import { Dispatch } from "redux";

export class DeliveryPeriodsLoaded extends Event {
    constructor(public deliveryPeriods: DeliveryPeriod[]) {
        super(DeliveryPeriodsLoaded.EventName);
    }

    public static EventName: string = "DELIVERY_PERIODS_LOADED";
}

export class DeliveryPeriodAdded extends Event {
    constructor(public newDeliveryPeriod: DeliveryPeriod) {
        super(DeliveryPeriodAdded.EventName);
    }

    public static EventName: string = "DELIVERY_PERIOD_ADDED";
}

export class DeliveryPeriodUpdated extends Event {
    constructor(public deliveryPeriod: DeliveryPeriod) {
        super(DeliveryPeriodUpdated.EventName);
    }

    public static EventName: string = "DELIVERY_PERIOD_UPDATED";
}

export class DeliveryPeriodDeleted extends Event {
    constructor(public deliveryPeriod: DeliveryPeriod) {
        super(DeliveryPeriodDeleted.EventName);
    }

    public static EventName: string = "DELIVERY_PERIOD_DELETED";
}

export class DeliveryPeriodDeletedWithId extends Event {
    constructor(public deliveryPeriodId: string) {
        super(DeliveryPeriodDeletedWithId.EventName);
    }

    public static EventName: string = "DELIVERY_PERIOD_DELETED_With_Id";
}


export class DeliveryPeriodActions {

    @Throttle(1000, true, false)
    private static doLoad(commodityId: number, dispatch: Dispatch): Promise<EventAction<DeliveryPeriodsLoaded>> {
        return deliveryPeriodService.listDeliveryPeriods(commodityId)
            .then(deliveryPeriodResponse => {
                return dispatch(new DeliveryPeriodsLoaded(deliveryPeriodResponse.deliveryPeriods).toObject());
            })
            .catch((error: any) => {
                loggingService.error('Failed to load delivery periods', error);
                throw error;
            });
    }

    public static loadDeliveryPeriods(commodityId?: number): (dispatch: Dispatch) => Promise<DeliveryPeriod[]> {
        return async function (dispatch) {
            const result = await DeliveryPeriodActions.doLoad(commodityId, dispatch);
            return result.deliveryPeriods;
        }
    }

    public static createDeliveryPeriod(deliveryPeriod: DeliveryPeriod): (dispatch: Dispatch) => EventAction<DeliveryPeriodAdded> {
        return dispatch => dispatch(new DeliveryPeriodAdded(deliveryPeriod).toObject());
    }

    public static updateDeliveryPeriod(newValue: DeliveryPeriod, oldValue: DeliveryPeriod): ActionWithDispatch<DeliveryPeriodUpdated, void> {
        return trackApiCall(dispatch => {
            dispatch(new DeliveryPeriodUpdated(newValue).toObject());
            return deliveryPeriodService
                .updateDeliveryPeriod(newValue)
                .catch((error) => {
                    dispatch(new DeliveryPeriodUpdated(oldValue).toObject());
                    throw error;
                });
        });
    }

    public static deleteDeliveryPeriod(deliveryPeriod: DeliveryPeriod): ActionWithDispatch<DeliveryPeriodDeleted> {
        return trackApiCall((dispatch) =>
            deliveryPeriodService.deleteDeliveryPeriod(deliveryPeriod).then(() => dispatch(new DeliveryPeriodDeleted(deliveryPeriod).toObject()))
        );
    }
}